/** Created by razial on 16.02.2026. */

const EditorPointer = function (userId) {
    cleverapps.EventEmitter.call(this);

    this.userId = userId;
    this.x = 0;
    this.y = 0;
};

EditorPointer.prototype = Object.create(cleverapps.EventEmitter.prototype);
EditorPointer.prototype.constructor = EditorPointer;

EditorPointer.prototype.setPosition = function (x, y) {
    this.x = x;
    this.y = y;

    this.trigger("updatePosition");
};
